import type * as Types from '../../types/graphql-base'

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type GetCurrentUserQueryVariables = Types.Exact<{ [key: string]: never }>

export type GetCurrentUserQuery = {
  __typename?: 'Query'
  viewer: {
    __typename?: 'User'
    isAdmin?: boolean | null
    name?: string | null
    id: string
    email?: string | null
    viewerCanCreateAccessProfile: boolean
    viewerCanSendMessage: boolean
    viewerCanSeeVisitorCheckInRequests: boolean
    viewerCanSeeLocalNetworks?: boolean | null
    viewerCanAddUser?: boolean | null
    viewerCanAddMicrosoftSSOUser?: boolean | null
    viewerCanUseSystemAdminMode?: boolean | null
    viewerCanSeeOrganizations?: boolean | null
    viewerCanCreateOrganization?: boolean | null
    viewerPreferences?: {
      __typename?: 'UserPreferences'
      marketingConsentAccepted?: boolean | null
    } | null
    accessProfiles?: {
      __typename?: 'UserAccessProfileConnection'
      totalCount: number
    } | null
  }
}

export type GetTimezonesQueryVariables = Types.Exact<{ [key: string]: never }>

export type GetTimezonesQuery = {
  __typename?: 'Query'
  timezones: Array<string>
}

export type GetLanguagesQueryVariables = Types.Exact<{ [key: string]: never }>

export type GetLanguagesQuery = {
  __typename?: 'Query'
  languages: Array<{ __typename?: 'Language'; id: string; name: string }>
}

export type GetIfUserExistsQueryVariables = Types.Exact<{
  email: Types.Scalars['String']
}>

export type GetIfUserExistsQuery = {
  __typename?: 'Query'
  viewer: {
    __typename?: 'User'
    user?: { __typename?: 'User'; id: string; hasAppAccount: boolean } | null
  }
}

export type SharedAccessZonesListQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']>
  last?: Types.InputMaybe<Types.Scalars['Int']>
  after?: Types.InputMaybe<Types.Scalars['String']>
  before?: Types.InputMaybe<Types.Scalars['String']>
  name?: Types.InputMaybe<Types.Scalars['String']>
}>

export type SharedAccessZonesListQuery = {
  __typename?: 'Query'
  viewer: {
    __typename?: 'User'
    accessZones?: {
      __typename?: 'UserAccessZoneConnection'
      totalCount: number
      pageInfo: {
        __typename?: 'PageInfo'
        startCursor?: string | null
        endCursor?: string | null
        hasNextPage?: boolean | null
        hasPreviousPage?: boolean | null
      }
      nodes: Array<{ __typename?: 'AccessZone'; id: string; name: string }>
    } | null
  }
}

export const GetCurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCurrentUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isAdmin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewerPreferences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'marketingConsentAccepted',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accessProfiles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewerCanCreateAccessProfile' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewerCanSendMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'viewerCanSeeVisitorCheckInRequests',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewerCanSeeLocalNetworks' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewerCanAddUser' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewerCanAddMicrosoftSSOUser' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewerCanUseSystemAdminMode' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewerCanSeeOrganizations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewerCanCreateOrganization' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>
export const GetTimezonesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTimezones' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timezones' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTimezonesQuery, GetTimezonesQueryVariables>
export const GetLanguagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLanguages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLanguagesQuery, GetLanguagesQueryVariables>
export const GetIfUserExistsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetIfUserExists' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'email' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasAppAccount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetIfUserExistsQuery,
  GetIfUserExistsQueryVariables
>
export const SharedAccessZonesListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SharedAccessZonesList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'before' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accessZones' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'first' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'last' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'last' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'after' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'after' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'before' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'before' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'name' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'name' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startCursor' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endCursor' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasNextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasPreviousPage' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SharedAccessZonesListQuery,
  SharedAccessZonesListQueryVariables
>
